// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa240.stage.monatest.icu/auto-open-api-spec.yaml 1.6.65
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializes FrequencyTime from the database
 * @see #/components/schemas/FrequencyTime - reference to schema in open-api-spec.yaml
 * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
 * @version 1.6.65
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface FrequencyTime {
    /**
     * Prescription Frequency Time Id
     * @dataFormat uuid
     */
    readonly id: string;
    /**
     * code of the prescription frequency this frequency time refers to.
     * @dataFormat uuid
     */
    prescription_frequency_code?: string;
    /**
     * The frequency at hour
     *
     */
    hour?: number;
    /**
     * The frequency at minute
     *
     */
    minute?: number;
    /**
     * The repetition frequency
     *
     */
    repeat_after_minutes: number;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for FrequencyTime
 */
export namespace FrequencyTime {
    /**
     * FrequencyTime Frontend Model with camelCase properties
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * Prescription Frequency Time Id
         * @dataFormat uuid
         */
        readonly id: string;
        /**
         * code of the prescription frequency this frequency time refers to.
         * @dataFormat uuid
         */
        prescriptionFrequencyCode?: string;
        /**
         * The frequency at hour
         * @type number (`dataFormat` is missing)
         */
        hour?: number;
        /**
         * The frequency at minute
         * @type number (`dataFormat` is missing)
         */
        minute?: number;
        /**
         * The repetition frequency
         * @type number (`dataFormat` is missing)
         */
        repeatAfterMinutes: number;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * FrequencyTime DTO
     * Transforms FrequencyTime model from/to API object
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend FrequencyTime model */
        static toModel(obj: FrequencyTime): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend FrequencyTime model */
        static toApi(obj: Model): FrequencyTime {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as FrequencyTime;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
